<template>
  <section class="tw-h-screen tw-py-48 tw-bg-center tw-relative tw-bg-cover" :style="{'background-image': `url(${pageOptions ? !pageOptions.custom_highlight ? singles[0] ? singles[0].images[0].url : albums[0].images[0].url : isVideo == false ? pageOptions ? (pageOptions.featured_img ? '/'+pageOptions.featured_img : singles[0] ? singles[0].images[0].url : albums[0].images[0].url) : singles[0] ? singles[0].images[0].url : albums[0].images[0].url : '' : singles[0] ? singles[0].images[0].url : albums[0].images[0].url})`}" id="banner">
    <div class="tw-absolute tw-w-full tw-h-full tw-overflow-hidden tw-top-0 tw-left-0" v-if="isVideo == true">
      <video :src="'/'+pageOptions.featured_img" class="full" autoplay loop muted playsinline></video>
    </div>
    <div class="tw-container tw-mx-auto tw-h-full tw-relative tw-z-20">
      <div class="tw-flex tw-flex-wrap tw-items-end tw-justify-center tw-h-full tw-relative">
        <div class="tw-block tw-w-full tw-text-center tw-relative tw-pb-16">
          <p class="tw-font-sans tw-text-white tw-font-light tw-text-sm lg:tw-text-xl tw-text-center tw-p-0 tw-mt-3 tw-mb-0 tw-uppercase tw-tracking-widest">{{pageOptions ? !pageOptions.custom_highlight ? (selectedLanguageObj.title_home) : (pageOptions.featured_subtitle ? pageOptions.featured_subtitle : (selectedLanguageObj.title_home)) : (selectedLanguageObj.title_home)}}</p>
          <h1 class="tw-font-sans tw-text-white tw-font-extrabold tw-text-3xl lg:tw-text-5xl tw-text-center tw-m-0 tw-uppercase">{{pageOptions ? !pageOptions.custom_highlight ? singles[0] ? singles[0].name : albums[0].name : (pageOptions.featured_title ? pageOptions.featured_title : singles[0] ? singles[0].name : albums[0].name) : singles[0] ? singles[0].name : albums[0].name}}</h1>
          <v-btn depressed small color="white" :target="pageOptions ? !pageOptions.custom_highlight ? '_blank' : (pageOptions.featured_url ? '_blank' : '_self') : '_self'" :href="pageOptions ? !pageOptions.custom_highlight ? singles[0] ? tenant ? `/single/${singles[0].id}` : `/single/${artist.artista_url}/${singles[0].id}` : tenant ? `/album/${albums[0].id}` : `/album/${artist.artista_url}/${albums[0].id}` : (pageOptions.featured_url ? pageOptions.featured_url : singles[0] ? tenant ? `/single/${singles[0].id}` : `/single/${artist.artista_url}/${singles[0].id}` : tenant ? `/album/${albums[0].id}` : tenant ? `/album/${albums[0].id}` : `/album/${artist.artista_url}/${albums[0].id}`) : singles[0] ? tenant ? `/single/${singles[0].id}` : `/single/${artist.artista_url}/${singles[0].id}` : tenant ? `/album/${albums[0].id}` : `/album/${artist.artista_url}/${albums[0].id}`" light class="tw-font-sans tw-mt-5"><v-icon left class="tw-text-xs">fas fa-play</v-icon> {{pageOptions ? !pageOptions.custom_highlight ? (selectedLanguageObj.sub_title_home) : (pageOptions.button_text ? pageOptions.button_text : (selectedLanguageObj.sub_title_home)) : (selectedLanguageObj.sub_title_home)}}</v-btn>
        </div>
      </div>
    </div>
  </section>
</template>


<script>

import Layout from '@/Shared/Layout2';
import EventBus from '@/eventbus';
import pt from "../../../../../lang/smartsite/layout_2/layout_2.js";
 
require('readmore-js');

export default {
  mixins: [pt],
  layout: (h, page) => h(Layout, [page]),
  layout: Layout,
  props: ['artist', 'pageOptions', 'spotifyArtist', 'albums', 'singles'],
  metaInfo() {
    return {
      title: ``,
    }
  },
  data(){
    return{
      isVideo: false,
      selectedLanguageObj: {},
    }
  },
  methods:{
    checkVideo(){
      let url = this.pageOptions ? this.pageOptions.featured_img : '';
      if(url){
          let extension = url.replace(/^.*\./, '');
          if(extension == 'mp4'){
              return this.isVideo = true;
          } 
          return this.isVideo = false;
      }
    },
    setLanguage() {
      if(this.$page.props.lang == 'US') {
        this.selectedLanguageObj = pt.data().en
      } else {
        this.selectedLanguageObj = pt.data().pt
      }
    }
  }, 
  created(){
    EventBus.$emit('artist', {'artist': this.artist, 'pageOptions': this.pageOptions});
  },
  mounted(){
    this.checkVideo();
    this.setLanguage();
  }
}
</script>

<style>

.navbar {
  position: fixed;
  height: 60px;
  width: 100%;
}

.upNav {
  height: 40px;
  background: rgba(0, 0, 0, 0.2);
}

.theme--dark.v-app-bar.v-toolbar.v-sheet {
  background: transparent;
}

.video-example {
  top: -215px;
}

#link_upnav {
  color: white;
}

@media (min-width: 1024px) {
  .navbar {
    width: 100% !important;
  }

  .upNav {
    padding: 5px;
  }
}

@media (min-width: 960px) {
  .default_width, .default_width__video {
    max-width: 100%;
  }
}

@media (min-width: 768px) {
  #fit {
    width: fit-content;
  }
}

.full {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  object-fit: cover;
}

</style>